import styled from 'styled-components';
import { Flex } from 'antd';

export const SLogoWrapper = styled(Flex)`
  cursor: pointer;
  height: 85px;
`;

export const SLogoText = styled(Flex)`
  font-size: 22px;
  font-weight: 500;
`;
